import { Spacer } from '../Spacer';
import { TileRowSkeleton } from '../Tile/TileRowSkeleton';

export interface SkeletonRowLoadingProps {
  itemsCount: number;
  small?: boolean;
  medium?: boolean;
}

export const SkeletonRowLoading = ({
  itemsCount,
  small,
  medium,
}: SkeletonRowLoadingProps) => {
  const items = Array.from({ length: itemsCount }, (_, i) => i);

  return (
    <div>
      {items.map((_prop, index) => (
        <div key={index}>
          {small ? (
            <TileRowSkeleton small />
          ) : medium ? (
            <TileRowSkeleton medium />
          ) : (
            <TileRowSkeleton />
          )}
          <Spacer amount={1.25} />
        </div>
      ))}
    </div>
  );
};
